import { EventProductItemModel } from '@app/events/shared/event-product-item.model';
import { EventProductItemVariantSelectionRequest } from '@app/events/shared/event-product-item-variant-selection.model';

export interface EventProductItemCreatePayload {
  quantity: number | null;
  amount: number | null;
  date_purchased: string;
  is_paid: boolean;
  product_id: number | null;
  event_id: number;
  event_timeline_item_id?: number | null;
  variant_selections?: EventProductItemVariantSelectionRequest[];
}

const getDefaultDatePurchased = (): string => {
  return new Date().toISOString().slice(0, 19).replace('T', ' ');
};

const formatDateTime = (value: unknown): string | null => {
  if (value instanceof Date) {
    if (isNaN(value.getTime())) {
      return null;
    }
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    const hours = String(value.getHours()).padStart(2, '0');
    const minutes = String(value.getMinutes()).padStart(2, '0');
    const seconds = String(value.getSeconds()).padStart(2, '0');
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }

  if (typeof value === 'string') {
    return value;
  }

  return null;
};

export const buildEventProductItemCreatePayload = (
  item: EventProductItemModel,
  eventId: number,
): EventProductItemCreatePayload => {
  const variantSelections = (item.variant_selections ?? [])
    .filter((selection) => selection?.variant_id !== undefined && selection?.variant_id !== null)
    .map((selection) => ({
      variant_id: selection.variant_id,
      variant_option_id: selection.variant_option_id ?? null,
      quantity: selection.quantity ?? 0,
      notes: selection.notes ?? null,
    }));

  const payload: EventProductItemCreatePayload = {
    quantity: item.quantity ?? null,
    amount: item.amount ?? null,
    date_purchased: formatDateTime(item.date_purchased) ?? getDefaultDatePurchased(),
    is_paid: item.is_paid ?? false,
    product_id: item.product_id ?? item.product?.id ?? null,
    event_id: eventId,
  };

  if (variantSelections.length > 0) {
    payload.variant_selections = variantSelections;
  }

  if (item.event_timeline_item_id !== undefined) {
    payload.event_timeline_item_id = item.event_timeline_item_id ?? null;
  }

  return payload;
};
